export function downloadFile(file: { data: Uint8Array; filename: string }) {
  const url = URL.createObjectURL(new Blob([file.data], { type: "application/octet-stream" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = file.filename;
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
